import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LinkedOrganizationDto } from '../entities/linked-organization-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class LinkedOrganizationApiService extends ParentApiService {
  private readonly baseUrl = `${environment.webApiAddress}/api/linked-organizations`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getLinkedOrganizations(stayOnPageIfError?: boolean): Observable<LinkedOrganizationDto[]> {
    return this.http.get<LinkedOrganizationDto[]>(this.baseUrl, { headers: this.headersFor(stayOnPageIfError) });
  }

  disconnect(organizationId: number, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${organizationId}`, { headers: this.headersFor(stayOnPageIfError) });
  }
}
